import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Swal from "sweetalert2";
import { Button, Label, Input } from "reactstrap";
import axios from "axios";

// Cambio de la propia contraseña (el servidor usa siempre el usuario de la sesión)
function Password() {
  const { user } = useContext(AuthContext);
  const URL = `${process.env.REACT_APP_URL_USERS}/passwordUser/${user.id}`;
  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [repite, setRepite] = useState("");
  const [guardando, setGuardando] = useState(false);

  const cambiar = async () => {
    if (nueva.length < 4) return Swal.fire({ icon: "warning", title: "La contraseña nueva debe tener al menos 4 caracteres" });
    if (nueva !== repite) return Swal.fire({ icon: "warning", title: "La contraseña nueva no coincide" });
    setGuardando(true);
    try {
      await axios.patch(URL, { password: actual, passwordNuevo: nueva }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
      setActual(""); setNueva(""); setRepite("");
      Swal.fire({ icon: "success", title: "Contraseña actualizada", timer: 1800, showConfirmButton: false });
    } catch (e) {
      Swal.fire({ icon: "error", title: "No se cambió", text: (e.response && e.response.data && e.response.data.message) || "Intenta de nuevo" });
    } finally {
      setGuardando(false);
    }
  };

  return (
    <>
      <Label>Contraseña actual</Label>
      <Input type="password" value={actual} onChange={(e) => setActual(e.target.value)} />
      <Label className="mt-2">Contraseña nueva</Label>
      <Input type="password" value={nueva} onChange={(e) => setNueva(e.target.value)} />
      <Label className="mt-2">Repite la contraseña nueva</Label>
      <Input type="password" value={repite} onChange={(e) => setRepite(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") cambiar(); }} />
      <Button color="success" className="mt-3" block disabled={guardando || !actual || !nueva} onClick={cambiar}>Cambiar contraseña</Button>
    </>
  );
}

export default Password;
